import { useEffect, useState } from "react";
import { api } from "../lib/api";

/**
 * Renders a backend-served image that requires a Bearer token.
 * Accepts either a storage path or a legacy base64 data URL.
 */
export default function AuthImage({ path, alt = "", className = "" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let revoke = null;
    let cancelled = false;
    if (!path) return;
    // Legacy base64 fallback
    if (path.startsWith("data:") || (path.length > 200 && !path.includes("/"))) {
      setSrc(path.startsWith("data:") ? path : `data:image/jpeg;base64,${path}`);
      return;
    }
    api.get(`/photos/${path}`, { responseType: "blob" }).then((r) => {
      if (cancelled) return;
      const url = URL.createObjectURL(r.data);
      revoke = url;
      setSrc(url);
    }).catch(() => {});
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (!src) {
    return <div className={`${className} bg-paper-100 animate-pulse`} />;
  }
  return <img src={src} alt={alt} className={className} />;
}
